enum TEBadgeSignal {
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
  Info = 'info',
  Brand = 'brand',
  Neutral = 'neutral',
  Dot = 'dot',
  Number = 'number',
}

export default TEBadgeSignal;
